import React from 'react'
import Sticky from 'react-sticky-el'
import PropTypes from 'prop-types'

import Breadcrumb from 'components/Breadcrumb'
import CollectionButton from 'components/CollectionButton'
import InquiryButton from '../InquiryButton'

import './index.less'

const NavigationHeader = (props) => {
  const {
    provider,
    breadcrumb,
    queryParams,
  } = props

  const showInquiryButton = provider.canBeInquired && !['EventRoom', 'EventIdea'].includes(provider.type)

  return (
    <Sticky
      className="provider-navbar"
      boundaryElement=".provider-profile-page"
      hideOnBoundaryHit={false}
    >
      <nav>
        <div className="provider-navbar__menu">
          <Breadcrumb html={breadcrumb} />

          {showInquiryButton && (
            <div className="provider-navbar__menu__actions">
              <InquiryButton
                provider={provider}
                className="provider-navbar__menu__cta"
                size="large"
                queryParams={queryParams}
              />
              <CollectionButton
                providerId={provider.id}
                collections={props.collections || []}
                className="provider-navbar__menu__collection-cta"
                showLabel
              />
            </div>
          )}
        </div>
      </nav>
    </Sticky>
  )
}

NavigationHeader.propTypes = {
  provider: PropTypes.object.isRequired,
  breadcrumb: PropTypes.string,
  queryParams: PropTypes.object,
  collections: PropTypes.array,
}

export default NavigationHeader
